import React from "react";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import styled from "styled-components";
import ActionsContextV2 from "../ActionsContextV2";

const Container = styled.div``;

export default function ActionPendingCompletedTabs({ formProps }) {
  const context = React.useContext(ActionsContextV2);

  const pendingCount = context;

  const handleChange = (event, newValue) => {
    context.setPendingCompletedTab(newValue);
    context.setCategoryFilterText("");
    context.setComplianceFilterText("");
  };
  return (
    <Tabs
      indicatorColor="primary"
      value={context.pendingCompletedTab}
      onChange={handleChange}
    >
      <Tab
        label={`Pending (${context.actionsRedux.selectedProjectFunctionDetails.pendingActions.length})`}
      />
      <Tab
        label={`Completed (${context.actionsRedux.selectedProjectFunctionDetails.approvedActions.length})`}
      />
    </Tabs>
  );
}
